module.exports = __webpack_public_path__ + "img/ghan-thin-02.9deefa58.jpg";